<app-notifications-history
    class="tw-w-full"
    [notifications]="notifications$ | async"
    [lastViewed]="latestActivitiesViewed$ | async"
    [loading]="loading$ | async"
    [nextPageLoading]="nextPageLoading$ | async"
    [noMoreNotifications]="noMoreNotifications$ | async"
    [notificationTypesStorage]="notificationTypesStorage"
    (loadMoreNotifications)="handleLoadMore($event)"
    (filterNotificationHistory)="handleNotificationFilters($event)">
</app-notifications-history>
